"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var reselect_1 = require("reselect");
var Slot_1 = require("../../utils/Slot");
var PlannerSorting_1 = require("../../types/enums/PlannerSorting");
var RecordingMetaStatus_1 = require("../../types/enums/RecordingMetaStatus");
var utils_1 = require("../../utils/utils");
var Title_1 = require("../../utils/Title");
var dayjs_1 = __importDefault(require("dayjs"));
var constants_1 = require("./constants");
var moduleState = function (rootState) { return rootState[constants_1.namespace]; };
var recordingsState = reselect_1.createSelector(moduleState, function (state) { return state.recordings; });
exports.recordings = reselect_1.createSelector(recordingsState, function (rs) { return rs; });
exports.reformatRecordingAPIToRecordingPlaybackMeta = function (recordingsList) {
    return recordingsList
        ? recordingsList.reduce(function (result, slotRecording) {
            var _a;
            try {
                return __spreadArrays(result, [
                    {
                        id: slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.id,
                        scheduledRecordingId: slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.id,
                        status: RecordingMetaStatus_1.RecordingMetaStatus.SCHEDULED,
                        size: 0,
                        playInfo: '',
                        slot: slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.slot,
                        start: dayjs_1.default((_a = slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.slot) === null || _a === void 0 ? void 0 : _a.start).unix(),
                        preGuard: slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.preGuard,
                        postGuard: slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.postGuard,
                        retentionPeriod: slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.retentionPeriod,
                    },
                ]);
            }
            catch (err) {
                return result;
            }
        }, [])
        : [];
};
exports.scheduledRecordingsState = reselect_1.createSelector(moduleState, function (state) { return state.scheduledRecordings; });
exports.getSortOptions = function () { return [
    {
        id: PlannerSorting_1.PlannerSorting.NEWEST,
        title: 'Newest',
    },
    {
        id: PlannerSorting_1.PlannerSorting.OLDEST,
        title: 'Oldest',
    },
    {
        id: PlannerSorting_1.PlannerSorting.ALPHABETICAL,
        title: 'A-Z',
    },
]; };
exports.selectedPlannerSorting = reselect_1.createSelector(moduleState, function (state) { return state.plannerSorting; });
var getRecordingsMetaGroupByBrand = function (scheduledRecordingSet, recordedMetaList, sorting) {
    var formattedScheduledRecordings = exports.reformatRecordingAPIToRecordingPlaybackMeta(scheduledRecordingSet === null || scheduledRecordingSet === void 0 ? void 0 : scheduledRecordingSet.slots);
    var now = dayjs_1.default();
    var filteredScheduledRecordings = formattedScheduledRecordings.filter(function (formattedRecording) {
        var _a;
        // filter out the ones that are already finished
        return now.isBefore(dayjs_1.default((_a = formattedRecording.slot) === null || _a === void 0 ? void 0 : _a.end)) &&
            utils_1.isNilOrEmpty(recordedMetaList.find(function (_a) {
                var programmeId = _a.programmeId, slot = _a.slot;
                var _b, _c, _d;
                // TODO backward compatibility for old recordings which don't have slot id
                return (slot === null || slot === void 0 ? void 0 : slot.id) ? (slot === null || slot === void 0 ? void 0 : slot.id) === ((_b = formattedRecording.slot) === null || _b === void 0 ? void 0 : _b.id)
                    : programmeId === ((_d = (_c = formattedRecording.slot) === null || _c === void 0 ? void 0 : _c.programme) === null || _d === void 0 ? void 0 : _d.id);
            }));
    });
    var sortedRecordings = __spreadArrays(filteredScheduledRecordings, recordedMetaList);
    // by default, all the recordings would be sorted by newest
    sortedRecordings.sort(function (a, b) {
        // the scheduled ones should always be the last.
        if (a.status !== RecordingMetaStatus_1.RecordingMetaStatus.SCHEDULED && b.status === RecordingMetaStatus_1.RecordingMetaStatus.SCHEDULED) {
            return -1;
        }
        if (a.status === RecordingMetaStatus_1.RecordingMetaStatus.SCHEDULED && b.status !== RecordingMetaStatus_1.RecordingMetaStatus.SCHEDULED) {
            return 1;
        }
        return sorting === PlannerSorting_1.PlannerSorting.OLDEST ? a.start - b.start : b.start - a.start;
    });
    var getBrand = function (slot) {
        var _a, _b;
        if (Title_1.isPpvProgram(slot === null || slot === void 0 ? void 0 : slot.programme)) {
            return (_a = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _a === void 0 ? void 0 : _a.event;
        }
        if (Slot_1.isShow(slot)) {
            return (_b = slot === null || slot === void 0 ? void 0 : slot.programme) === null || _b === void 0 ? void 0 : _b.show;
        }
        return slot === null || slot === void 0 ? void 0 : slot.programme;
    };
    var brandsById = sortedRecordings.reduce(function (result, recordingMeta) {
        var _a, _b;
        var slot = recordingMeta.slot, _c = recordingMeta.size, size = _c === void 0 ? 0 : _c;
        var brand = slot && getBrand(slot);
        if (slot && brand) {
            if (result[brand.id]) {
                var resBrand = result[brand.id];
                // always keep the recordings for overlay sorted by newest
                if (sorting === PlannerSorting_1.PlannerSorting.OLDEST) {
                    resBrand.recordings.unshift(recordingMeta);
                }
                else {
                    resBrand.recordings.push(recordingMeta);
                }
                return __assign(__assign({}, result), (_a = {}, _a[brand.id] = __assign(__assign({}, resBrand), { size: resBrand.size + size }), _a));
            }
            return __assign(__assign({}, result), (_b = {}, _b[brand.id] = __assign(__assign({}, brand), { size: size, recordings: [recordingMeta] }), _b));
        }
        return result;
    }, {});
    var brandsByIdArray = Object.values(brandsById);
    if (sorting === PlannerSorting_1.PlannerSorting.ALPHABETICAL) {
        brandsByIdArray.sort(function (a, b) { return a.title.localeCompare(b.title); });
    }
    return brandsByIdArray;
};
exports.recordingsMetaGroupByBrand = reselect_1.createSelector(exports.scheduledRecordingsState, recordingsState, exports.selectedPlannerSorting, function (srs, rs, sorting) {
    return getRecordingsMetaGroupByBrand(srs.data, rs, sorting);
});
exports.scheduledRecordingsMetaGroupByBrand = reselect_1.createSelector(exports.scheduledRecordingsState, 
// keep recordingsState here even it's not used.
// this is to make sure scheduled recordings updated once ongoing one finishes.
recordingsState, function (srs) {
    return getRecordingsMetaGroupByBrand(srs.data, [], PlannerSorting_1.PlannerSorting.OLDEST);
});
exports.completedRecordingsMetaGroupByBrand = reselect_1.createSelector(recordingsState, exports.selectedPlannerSorting, function (sr, sorting) {
    return getRecordingsMetaGroupByBrand(null, sr, sorting);
});
var recordingSettingsState = reselect_1.createSelector(moduleState, function (state) { return state.recordingSettings; });
exports.usedStorage = reselect_1.createSelector(recordingSettingsState, function (recordingSettings) { return recordingSettings.usedStorage || 0; });
exports.usedDiskspace = reselect_1.createSelector(recordingSettingsState, function (recordingSettings) { return recordingSettings.usedDiskspace || 0; });
exports.freeDiskspace = reselect_1.createSelector(recordingSettingsState, function (recordingSettings) { return recordingSettings.freeDiskspace || 0; });
exports.scheduledRecordings = reselect_1.createSelector(exports.scheduledRecordingsState, function (state) { return state.data; });
exports.recordProgramState = reselect_1.createSelector(moduleState, function (state) { return state.recordProgramme; });
exports.recordProgramError = reselect_1.createSelector(exports.recordProgramState, 
// To avoid the whole QueuedRecordingSet saved duplicatedly in the sub module,
// the data is saved with known error only, e.g. SubscriptionNeeded.
function (state) { return state.data || state.error; });
exports.recordSeriesLinkState = reselect_1.createSelector(moduleState, function (state) { return state.recordSeriesLink; });
exports.recordSeriesLinkError = reselect_1.createSelector(exports.recordSeriesLinkState, function (state) { return state.data || state.error; });
exports.scheduledRecordingBySlotIdFromGQL = reselect_1.createSelector(exports.scheduledRecordingsState, function (rs) { return function (slotId) { var _a; return (_a = rs.data.slots) === null || _a === void 0 ? void 0 : _a.find(function (slotRecording) { return (slotRecording === null || slotRecording === void 0 ? void 0 : slotRecording.slot.id) === slotId; }); }; });
exports.migrateRecordingsState = reselect_1.createSelector(moduleState, function (state) { return state.migrateRecordings; });
exports.isMigrationCompleted = reselect_1.createSelector(exports.migrateRecordingsState, function (ms) { return ms.data.isCompleted; });
//# sourceMappingURL=selectors.js.map